import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TransformationSection } from '../components/TransformationSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { PricingSection } from '../components/PricingSection';
import { FooterCTA } from '../components/FooterCTA';
import { DecorativeBackground } from '../components/DecorativeBackground';
export function SalesPage() {
  return <main className="relative w-full min-h-screen bg-cream font-body" data-id="element-129">
      <DecorativeBackground data-id="element-130" />
      <div className="relative z-10" data-id="element-131">
        <HeroSection data-id="element-132" />
        <AudienceSection data-id="element-133" />
        <ProductSection data-id="element-134" />
        <BonusSection data-id="element-135" />
        <TransformationSection data-id="element-136" />
        <GuaranteeSection data-id="element-137" />
        <PricingSection data-id="element-138" />
        <FooterCTA data-id="element-139" />
      </div>
    </main>;
}